import api from '@/lib/api.js';
import nanoid from 'nanoid';

function getOpposite(actionName) {
	if (actionName === 'block/addBlock') {
		return 'block/deleteBlock';
	}
	if (actionName === 'block/deleteBlock') {
		return 'block/addBlock';
	}
	if (actionName === 'block/updateBlock') {
		return 'block/updateBlock';
	}
	if (actionName === 'block/bulkUpdateBlocks') {
		return 'block/bulkUpdateBlocks';
	}
	if (actionName === 'block/bulkAddBlocks') {
		return 'block/bulkDeleteBlocks';
	}
	if (actionName === 'block/bulkDeleteBlocks') {
		return 'block/bulkAddBlocks';
	}
}

var store = {
	namespaced: true,

	state: {
		limit: 50,
		undoQueue: []
	},

	getters: {
		undoQueue: function(state) {
			return state.undoQueue;
		}
	},

	mutations: {
		UPDATE_UNDO_QUEUE: function(state, items) {
			state.undoQueue.push(items);
			if (state.undoQueue.length > state.limit) {
				state.undoQueue.shift();
			}
		},
		UNDO: function(state) {
			state.undoQueue.pop();
		}
	},

	actions: {
		async add(store, arr) {
			let newArr = [];
			for (let i = 0; i < arr.length; i++) {
				let name = arr[i].name;
				let payload = arr[i].payload;
				let obj = {
					name: name,
					payload: payload,
					_id: nanoid(),
					complete: false
				};
				if (arr[i].undo !== false) {
					newArr.push(obj);
				}
			}
			if (newArr.length > 0) {
				store.commit('UPDATE_UNDO_QUEUE', newArr);
			}
		},

		async undo(store) {
			let undoItem = store.state.undoQueue[store.state.undoQueue.length - 1];
			if (undoItem) {
				let actions = [];
				for (let i = 0; i < undoItem.length; i++) {
					let payload = undoItem[i].payload;
					let oppositeAction = getOpposite(undoItem[i].name);
					await store.dispatch(oppositeAction, payload, { root: true });
					actions.push({
						name: oppositeAction,
						payload: payload
					});
				}
				store.commit('UNDO');
				await store.dispatch('transaction/add', actions, { root: true });
			}
		}
	}
};

export default store;
